<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<promoblocks :items="page.promoblocks" />
		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

useHead({
	script: [
		{
			type: 'text/javascript',
			innerHTML: `
				window.Gifty = { key: '67d2e8b16c7c9' };
				(function (e, t) {
					var n = e.createElement(t);
					n.async = true;
					n.src = 'https://static.gifty.nl/js/widget.js';
					var r = e.getElementsByTagName(t)[0];
					r.parentNode.insertBefore(n, r);
				})(document, 'script');
			`,
		},
	],
});
</script>
